/***********************
 * REACT EMAIL ERROR BULLETIN
 ************************/

import React from "react"
import {
  Html,
  Head,
  Preview,
  Body,
  Container,
  Section,
  Row,
  Column,
  Text,
  Img,
  Link,
} from "@react-email/components"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

const baseUrl = `https://app.suvanto.care`

// Preview values
const previewValues = {
  bulletin: {
    header_fi: "Disturbance notice",
    informed_date: "21.05.2025",
    current_status: 1,
    start_time: "21.05.2025 08:00",
    end_time: "21.05.2025 12:00",
    updated: "21.05.2025 12:00",
  },
  targets: ["Suvanto Care app", "Video call"],
  bodyTexts: ["Error details line 1", "Error details line 2"],
}

const ErrorBulletinEmail = props => {
  const {
    t,
    bulletin = previewValues.bulletin,
    targets = previewValues.targets,
    bodyTexts = previewValues.bodyTexts,
  } = props

  // Determine status text
  const statusText =
    bulletin.current_status === 1
      ? t("Service outage")
      : bulletin.current_status === 2
      ? t("Service disruption")
      : t("Service operational")

  return (
    <Html lang="en">
      <Head>
        {/* <Font
          fontFamily="Poppins"
          fallbackFontFamily="Arial, sans-serif"
          webFont={{
            url: "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap",
            format: "woff2",
          }}
          fontWeight="400"
          fontStyle="normal"
        /> */}
      </Head>
      <Preview>{t("Disturbance notice")}</Preview>
      <Body style={main}>
        <Container style={container}>
          <Section style={card}>
            {/* Header title and date */}
            <Row>
              <Column style={topLeft}>
                <Text style={headerTitle}>{t("Disturbance notice")}</Text>
                <Text style={headerDate}>{bulletin.informed_date}</Text>
                {bulletin.updated && (
                  <Text style={update}>
                    {t("Updated") + " " + bulletin.updated}
                  </Text>
                )}
              </Column>
              <Column style={topRight}>
                <Img
                  src={`${baseUrl}/logo_suvanto_pyorea.png`}
                  alt="Suvanto Care"
                  style={img}
                />
              </Column>
            </Row>

            {/* Status */}
            <Text style={status}>
              {t("Current status") + ": "}
              {statusText}
            </Text>

            {/* Time table */}
            <Text style={timeLabel}>
              {t("Start time")} {bulletin.start_time}
            </Text>
            {bulletin.end_time && (
              <Text style={timeLabel}>
                {t("End time")} {bulletin.end_time}
              </Text>
            )}

            {/* Details */}
            <Section style={sectionBlock}>
              <Text style={secondTitle}>{bulletin.header_fi}</Text>
              {bodyTexts.map((line, idx) => (
                <div key={"key_" + idx} style={bodyText} dangerouslySetInnerHTML={{ __html: line }} />
              ))}
            </Section>

            {/* Affected services */}
            <Section style={sectionBlock}>
              <Text style={sectionHeading}>{t("Affected services")}</Text>
              {targets.map((tgt, idx) => (
                <Text key={""+idx} style={badge}>
                  {t(tgt)}
                </Text>
              ))}
            </Section>
          </Section>
        </Container>
        <Link
          href="https://www.suvantocare.fi/"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <Text style={footer}>© {new Date().getFullYear()} Suvanto Care</Text>
        </Link>
      </Body>
    </Html>
  )
}

ErrorBulletinEmail.propTypes = {
  t: PropTypes.func.isRequired,
  bulletin: PropTypes.shape({
    header_fi: PropTypes.string,
    informed_date: PropTypes.string,
    current_status: PropTypes.number,
    start_time: PropTypes.string,
    end_time: PropTypes.string,
  }),
  targets: PropTypes.arrayOf(PropTypes.string),
  bodyTexts: PropTypes.arrayOf(PropTypes.string),
}

export default withTranslation()(ErrorBulletinEmail)

// Styles
const main = {
  backgroundColor: "#f5f5f5",
  // fontFamily: "'Poppins', Arial, sans-serif",
  fontFamily: " Arial, sans-serif",
  padding: "20px 0",
}
const topLeft = {
  width: "50%",
}
const topRight = {
  textAlign: "right",
  width: "50%",
}

const img = {
  display: "inline-block",
  height: "50px",
  width: "auto",
  paddingRight: "30px",
  paddingTop: "0px",
}

const container = {
  maxWidth: "600px",
  margin: "0 auto",
}
const card = {
  backgroundColor: "#ffffff",
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  padding: "24px",
}
const headerTitle = {
  fontSize: "22px",
  fontWeight: "500",
  color: "#00a0d6",
  marginBottom: "5px",
}
const headerDate = {
  fontSize: "14px",
  color: "#888888",
}
const update = {
  color: "#888888",
  fontSize: "13px",
  marginTop: "0",
}
const status = {
  fontWeight: "600",
  marginTop: "16px",
  marginBottom: "16px",
}
const timeLabel = {
  fontSize: "14px",
}
const sectionBlock = {
  marginBottom: "24px",
}
const secondTitle = {
  fontSize: "18px",
  fontWeight: "500",
  marginBottom: "8px",
  color: "#495057",
}
const sectionHeading = {
  fontSize: "18px",
  fontWeight: "500",
  marginBottom: "8px",
  color: "#495057",
}
const bodyText = {
  fontSize: "14px",
  lineHeight: "1.5",
  marginBottom: "8px",
}
const badge = {
  display: "inline-block",
  backgroundColor: "#00a0d6",
  color: "#ffffff",
  fontSize: "12px",
  padding: "4px 8px",
  borderRadius: "35px",
  marginRight: "8px",
  marginBottom: "8px",
}
const footer = {
  fontSize: "12px",
  color: "#00a0d6",
  textAlign: "center",
  marginTop: "32px",
}
